import React, { useState, useContext, useEffect } from "react";
import Select from "react-select";
import { Link, useHistory } from "react-router-dom";
import { FilterContext } from "../FilterContextProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faSearch } from "@fortawesome/free-solid-svg-icons";
import Button from "../Components/Button";
import Input from "../Components/Input";
import SalesLayout from "./SalesLayout";
import useEvents from "../hooks/useEvents";
import useApi from "../Api/Api";
import { UserContext } from "../Auth/UserContextProvider";

const CompsList = () => {
  const { isAdmin } = useContext(UserContext);
  const { filterData } = useContext(FilterContext);
  const api = useApi();
  const history = useHistory();

  const {
    getEvents,
    events,
    pagy,
    currentPage,
    setCurrentPage,
    eventDates,
    eventDateOptions,
    handleEventDateSelect,
    renderCustomEventDateSelector,
    sortFilter,
    setSortFilter,
    resetPagination,
    setSearchFilter,
  } = useEvents("comp", "");

  const sortOptions = [
    {
      label: "Date",
      value: "date",
    },
    {
      label: "City",
      value: "city",
    },
    {
      label: "State",
      value: "state",
    },
    {
      label: "Venue",
      value: "name",
    },
    {
      label: "Recently added",
      value: "created_at",
    },
  ];

  const handleSortSelect = (option) => {
    if (option.value !== sortFilter) {
      setSortFilter(option.value);
      resetPagination();
      setCurrentPage(1);
    }
  };

  const [searchTimeout, setSearchTimeout] = useState();

  const handleSearchChange = (e) => {
    setSearchTimeout(e.target.value);
  };

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      setSearchFilter(searchTimeout);
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [searchTimeout, setSearchFilter]);

  const handlePageChange = (e) => {
    setCurrentPage(e.target.value);
  };

  const deleteEvent = (e, eventToDelete) => {
    e.preventDefault();
    const check = window.confirm(
      `Are you sure you want to delete ${eventToDelete.name}?`
    );
    if (check) {
      api.delete(`events/${eventToDelete.id}`).then(() => {
        getEvents(currentPage);
      });
    }
  };

  const renderSelectArtistMessage = () => {
    return (
      <div className="m-8 py-12 pl-4">
        Please select an artist from the filter in order to see events
      </div>
    );
  };

  const renderEventsTable = () => {
    return (
      <div>
        <div className="mx-12 flex justify-end text-sm pt-10">
          <Button
            onClick={() => history.push(`/sales/comps/create`)}
            className="button"
            text="Add New Comp"
          ></Button>
        </div>
        <div className="mx-10">
          <div className="text-2xl -mt-12 pb-8 font-medium">Comps List</div>
          <div className="-mt-5 mb-4 text-sm">
            <div className="flex">
              <div className="absolute mt-7 ml-2 text-black">
                <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
              </div>
              <div className="w-1/4 text-black text-xs">
                <Input
                  className="text-black text-xs"
                  onChange={handleSearchChange}
                  value={searchTimeout}
                  placeholder="Search for comps"
                  label="SEARCH"
                  bigPaddingLeft
                />
              </div>
              <div className="flex flex-col w-1/4 ml-2">
                <span className="text-xs text-black">SORT BY</span>
                <Select
                  id="sort_filter"
                  className="text-xs font-light"
                  placeholder="Select sort by..."
                  options={sortOptions}
                  onChange={handleSortSelect}
                  value={sortOptions?.filter(
                    (each) => each.value === sortFilter
                  )}
                />
              </div>
              <div className="flex flex-col text-sm w-1/4 ml-2">
                <span className="text-xs">SELECT DATE RANGE</span>
                <Select
                  id="date"
                  className="text-xs font-light w-full"
                  placeholder="Select date range"
                  options={eventDateOptions}
                  onChange={handleEventDateSelect}
                  value={eventDateOptions?.filter(
                    (each) => each.value === eventDates.dateButton
                  )}
                />
              </div>
            </div>
            <div className="my-4 w-1/2">
              {eventDates.dateButton === "custom" &&
                renderCustomEventDateSelector()}
            </div>
          </div>
        </div>
        {events.length > 0 ? (
          <form>
            <table className="w-full">
              <thead className="text-xs font-light">
                <tr className="text-left border-b-2 h-11 w-full text-black">
                  <td className="w-1/8 pl-6">DATE</td>
                  <td className="w-1/5">VENUE / LOCATION</td>
                  <td className="w-1/6">CITY</td>
                  <td className="w-thin">STATE</td>
                  <td className="w-thin">VALUE</td>
                  <td className="w-thin">FOR WHAT</td>
                  <td className="w-thin">FOR WHOM</td>
                  {isAdmin && <td className="w-thin text-center">ACTION</td>}
                </tr>
              </thead>
              <tbody>
                {events.map((eventToRender, i) => {
                  return (
                    <tr
                      key={eventToRender.id}
                      className="border-b text-sm h-11"
                    >
                      <td className="pl-6" id={`date_${i}`}>
                        {eventToRender.formattedDate}
                      </td>
                      <td id={`name_${i}`} className="text-blue-500">
                        <Link to={`/sales/comps/${eventToRender.id}/details`}>
                          {eventToRender?.name}
                        </Link>
                      </td>
                      <td id={`city_${i}`}>{eventToRender?.city}</td>
                      <td id={`state_${i}`}>{eventToRender?.state}</td>
                      <td id={`value_${i}`}>{eventToRender?.comment}</td>
                      <td id={`value_${i}`}>{eventToRender?.notes}</td>
                      <td id={`value_${i}`}>{eventToRender?.venue_rep_name}</td>
                      {isAdmin && (
                        <td className="text-center">
                          <button
                            onClick={(e) => deleteEvent(e, eventToRender)}
                          >
                            <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
                          </button>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </form>
        ) : sortFilter ? (
          <div className="py-16 mx-12">
            No comps match the provided filters
          </div>
        ) : (
          <div className="py-16 mx-12">
            No comps have been added for this artist yet
          </div>
        )}
      </div>
    );
  };

  return (
    <SalesLayout>
      <div className="text-black bg-gray-100 pt-2">
        <div className="mt-8 mx-8 text-black bg-white rounded-lg border">
          {filterData.artist_id
            ? renderEventsTable()
            : renderSelectArtistMessage()}
        </div>
        {events.length > 0 && (
          <footer className="text-sm mx-8 mt-4 flex justify-between">
            <div className="ml-1 mr-8">
              Showing <span className="font-bold">{pagy.from} </span>to
              <span className="font-bold"> {pagy.to} </span>of
              <span className="font-bold"> {pagy.count} </span>results
            </div>
            <div className="mr-8">
              Page {pagy.page} of {pagy.last}
            </div>
            <div className="flex -mt-2">
              <span>
                <Button
                  className={
                    pagy.page === 1
                      ? "button-white-disabled button-sm"
                      : "button button-white button-sm"
                  }
                  onClick={resetPagination}
                  text="First"
                  disabled={pagy.page === 1}
                ></Button>
              </span>
              <span className="mx-1">
                <Button
                  value={pagy.prev}
                  className={
                    !pagy.prev
                      ? "button-white-disabled button-sm"
                      : "button button-white button-sm"
                  }
                  onClick={handlePageChange}
                  text="Prev"
                  disabled={!pagy.prev}
                ></Button>
              </span>
              <span>
                <Button
                  value={pagy.next}
                  className={
                    !pagy.next
                      ? "button-white-disabled button-sm"
                      : "button button-white button-sm"
                  }
                  onClick={handlePageChange}
                  text="Next"
                  disabled={!pagy.next}
                ></Button>
              </span>
              <span className="ml-1">
                <Button
                  value={pagy.last}
                  className={
                    pagy.page === pagy.last
                      ? "button-white-disabled button-sm"
                      : "button button-white button-sm"
                  }
                  onClick={handlePageChange}
                  text="Last"
                  disabled={pagy.page === pagy.last}
                ></Button>
              </span>
            </div>
          </footer>
        )}
      </div>
    </SalesLayout>
  );
};

export default CompsList;
